<template>
  <div
    style="background: rgb(255, 255, 255); padding: 0px 25px; line-height: 1.4"
  >
    <div
      style="
        transition: width 500ms ease 0s, max-width 500ms ease 0s;
        margin: auto;
      "
    >
      <div
        id="bnnr-body-leftSide-a9a79050a-f59d-426d-a0e8-2d6ebc37f95b"
        style="padding-top: 15px; padding-bottom: 0px"
      >
        <div style="line-height: 1.5; font-size: 16px">
          <span
            >Wir verwenden Cookies und ähnliche Technologien auf unserer Website
            und verarbeiten personenbezogene Daten über dich, wie deine
            IP-Adresse. Wir teilen diese Daten auch mit Dritten. Die
            Datenverarbeitung kann mit deiner Einwilligung oder auf Basis eines
            berechtigten Interesses erfolgen, dem du in den individuellen
            Datenschutzeinstellungen widersprechen kannst. Du hast das Recht,
            nur in essenzielle Services einzuwilligen und deine Einwilligung in
            der Datenschutzerklärung zu einem späteren Zeitpunkt zu ändern oder
            zu widerrufen.</span
          >
          <div>
            <span
              style="
                margin-top: 7px;
                display: inline-block;
                max-width: 100%;
                border-radius: 1px;
                width: 50px;
                height: 3px;
                background: rgb(69, 179, 221);
              "
            ></span>
          </div>
          <!--    <span
            style="
              margin-top: 7px;
              display: inline-block;
              font-size: 13px;
              color: rgb(124, 124, 124);
            "
            >Einige Services verarbeiten personenbezogene Daten in den USA.
            Indem du der Nutzung dieser Services zustimmst, erklärst du dich
            auch mit der Verarbeitung deiner Daten in den USA gemäß Art. 49 (1)
            lit. a DSGVO einverstanden. Die USA werden vom EuGH als ein Land mit
            einem unzureichenden Datenschutzniveau nach EU-Standards angesehen.
            Insbesondere besteht das Risiko, dass deine Daten von US-Behörden zu
            Kontroll- und Überwachungszwecken verarbeitet werden, unter
            Umständen ohne die Möglichkeit eines Rechtsbehelfs.</span
          > -->
          <span
            style="
              margin-top: 20px;
              display: inline-block;
              font-size: 13px;
              color: rgb(124, 124, 124);
              height: 100px;
            "
            >Du bist unter 16 Jahre alt? Dann kannst du nicht in optionale
            Services einwilligen, oder du kannst deine Eltern oder
            Erziehungsberechtigten bitten, mit dir in diese Services
            einzuwilligen.</span
          >
        </div>
        <div style="margin-top: 10px; line-break: anywhere; line-height: 2">
          <span
            style="padding-right: 10px; font-size: 16px; white-space: nowrap"
            ><span
              ><strong style="color: rgb(69, 179, 221)">●</strong>&nbsp;<span
                style="vertical-align: middle"
                >Essenziell</span
              ></span
            ></span
          ><span
            style="padding-right: 10px; font-size: 16px; white-space: nowrap"
            ><span
              ><strong style="color: rgb(69, 179, 221)">●</strong>&nbsp;<span
                style="vertical-align: middle"
                >Funktional</span
              ></span
            ></span
          ><span
            style="padding-right: 10px; font-size: 16px; white-space: nowrap"
            ><span
              ><strong style="color: rgb(69, 179, 221)">●</strong>&nbsp;<span
                style="vertical-align: middle"
                >Statistik</span
              ></span
            ></span
          ><span
            style="padding-right: 10px; font-size: 16px; white-space: nowrap"
            ><span
              ><strong style="color: rgb(69, 179, 221)">●</strong>&nbsp;<span
                style="vertical-align: middle"
                >Marketing</span
              ></span
            ></span
          >
        </div>
      </div>
      <div
        id="bnnr-body-rightSide"
        style="
          max-width: 100%;
          background: rgb(255, 255, 255);
          padding-top: 10px;
          padding-bottom: 10px;
          width: 510px;
          position: relative;
          bottom: 0px;
          z-index: 1;
          display: flex;
          flex-wrap: wrap;
        "
      >
        <div
          style="
            text-decoration: none;
            border-radius: 1px;
            cursor: pointer;
            background-color: rgb(69, 179, 221);
            font-size: 19px;
            font-weight: normal;
            color: rgb(255, 255, 255);
            transition: background-color 250ms ease 0s, color 250ms ease 0s,
              border-color 250ms ease 0s;
            margin: 0px 0px 10px;
            padding: 10px;
            overflow: hidden;
            flex: 1 1 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            order: 0;
          "
        >
          <span
          @click="allowAllCookies()"
            style="
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: keep-all;
              overflow: hidden;
              cursor: pointer;
            "
            >Alle akzeptieren</span
          >
        </div>
        <div
          style="
            text-decoration: none;
            border-radius: 1px;
            cursor: pointer;
            background-color: rgb(255, 255, 255);
            font-size: 15px;
            font-weight: normal;
            color: rgb(69, 179, 221);
            transition: background-color 250ms ease 0s, color 250ms ease 0s,
              border-color 250ms ease 0s;
            margin: 0px 0px 10px;
            border: 2px solid rgb(69, 179, 221);
            padding: 5px;
            overflow: hidden;
            flex: 1 1 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            order: 1;
          "
        >
          <span
           @click="keepSettings()"
            style="
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: keep-all;
              overflow: hidden;
              cursor: pointer;
            "
            >Weiter ohne Einwilligung</span
          >
        </div>
        <div
          style="
            text-decoration: none;
            border-radius: 1px;
            font-size: 15px;
            font-weight: normal;
            color: rgb(124, 124, 124);
            transition: background-color 250ms ease 0s, color 250ms ease 0s,
              border-color 250ms ease 0s;
            margin: 0px 0px 10px;
            padding: 0px 5px;
            overflow: hidden;
            flex: 1 1 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            order: 2;
          "
        >
          <span
            style="
              text-overflow: ellipsis;
              word-break: keep-all;
              overflow: hidden;
              cursor: pointer;
            "
            @click="showSettings()"
            >Individuelle Privatsphäre-Einstellungen</span
          >
        </div>
      </div>
      

      <div style="margin-top: 10px; clear: both" v-if="show_settings">
        <div
          style="
            border: 1px solid rgb(244, 244, 244);
            padding: 20px;
            border-radius: 1px;
            text-align: left;
          "
        >
          <div
            style="
              color: rgb(43, 43, 43);
              font-size: 16px;
              font-weight: normal;
              text-align: left;
            "
          >
            <div
              style="
                cursor: not-allowed;
                opacity: 0.5;
                color: rgb(255, 255, 255);
                display: inline-block;
                background: rgb(69, 179, 221);
                border: 1px solid rgb(70, 155, 195);
                padding: 3px;
                height: 24px;
                width: 24px;
                margin-right: 10px;
                border-radius: 1px;
                vertical-align: middle;
                line-height: 0;
              "
            >
              <svg
                viewBox="64 64 896 896"
                focusable="false"
                style="width: auto; height: 100%"
                fill="currentColor"
              >
                <path
                  d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                ></path>
              </svg>
            </div>
            <span style="vertical-align: middle; cursor: pointer"
              >Essenziell ({{amount_cookies.essentiel}})</span
            >
            <div
              style="
                color: rgb(124, 124, 124);
                font-size: 15px;
                font-weight: normal;
                margin-top: 5px;
              "
            >
              Essential Services sind für die grundlegende Funktionalität der
              Website erforderlich. Sie enthalten nur technisch notwendige
              Services. Diesen Services kann nicht widersprochen
              werden.&nbsp;&nbsp;•&nbsp;&nbsp;<a
                href="#"
                style="color: rgb(124, 124, 124); text-decoration: none"
                >Service-Informationen anzeigen</a
              >
            </div>
          </div>
        </div>
        <div style="height: 10px"></div>
        <div
          style="
            border: 1px solid rgb(244, 244, 244);
            padding: 20px;
            border-radius: 1px;
            text-align: left;
          "
        >
          <div
            style="
              color: rgb(43, 43, 43);
              font-size: 16px;
              font-weight: normal;
              text-align: left;
            "
          >
            <div
              style="
                cursor: pointer;
                display: inline-block;
              "
            >
             <input type="checkbox" v-model="want_functional" />
            </div>
            <span style="vertical-align: middle; cursor: pointer"
              >Funktional ({{amount_cookies.functional}})</span
            >
            <div
              style="
                color: rgb(124, 124, 124);
                font-size: 15px;
                font-weight: normal;
                margin-top: 5px;
              "
            >
              Funktionale Services sind notwendig, um über die wesentliche
              Funktionalität hinausgehende Features wie hübschere Schriftarten,
              Videowiedergabe oder interaktive Web 2.0-Features bereitzustellen.
              Inhalte von z.B. Videoplattformen und Social Media Plattformen
              sind standardmäßig gesperrt und können zugestimmt werden. Wenn dem
              Service zugestimmt wird, werden diese Inhalte automatisch ohne
              weitere manuelle Einwilligung geladen.&nbsp;&nbsp;•&nbsp;&nbsp;<a
                href="#"
                style="color: rgb(124, 124, 124); text-decoration: none"
                >Service-Informationen anzeigen</a
              >
            </div>
          </div>
        </div>
        <div style="height: 10px"></div>
        <div
          style="
            border: 1px solid rgb(244, 244, 244);
            padding: 20px;
            border-radius: 1px;
            text-align: left;
          "
        >
          <div
            style="
              color: rgb(43, 43, 43);
              font-size: 16px;
              font-weight: normal;
              text-align: left;
            "
          >
            <div
              style="
                cursor: pointer;
                display: inline-block;
              "
            >
             <input type="checkbox" v-model="want_stat" />
                <path
                  d="M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                ></path>
              </svg>
            </div>
            <span style="vertical-align: middle; cursor: pointer"
              >Statistik ({{amount_cookies.stats}})</span
            >
            <div
              style="
                color: rgb(124, 124, 124);
                font-size: 15px;
                font-weight: normal;
                margin-top: 5px;
              "
            >
              Statistik Services werden benötigt, um pseudonymisierte Daten über
              die Besucher der Website zu sammeln. Die Daten ermöglichen es uns,
              die Besucher besser zu verstehen und die Webseite zu
              optimieren.&nbsp;&nbsp;•&nbsp;&nbsp;<a
                href="#"
                style="color: rgb(124, 124, 124); text-decoration: none"
                >Service-Informationen anzeigen</a
              >
            </div>
          </div>
        </div>
        <div style="height: 10px"></div>
        <div
          style="
            border: 1px solid rgb(244, 244, 244);
            padding: 20px;
            border-radius: 1px;
            text-align: left;
          "
        >
          <div
            style="
              color: rgb(43, 43, 43);
              font-size: 16px;
              font-weight: normal;
              text-align: left;
            "
          >
             <div
              style="
                cursor: pointer;
                display: inline-block;
              "
            >
             <input type="checkbox" v-model="want_marketing" />
                <path
                  d="M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                ></path>
              </svg>
            </div>
            <span style="vertical-align: middle; cursor: pointer"
              >Marketing ({{amount_cookies.marketing}})</span
            >
            <div
              style="
                color: rgb(124, 124, 124);
                font-size: 15px;
                font-weight: normal;
                margin-top: 5px;
              "
            >
              Marketing Services werden von uns und Dritten genutzt, um das
              Verhalten einzelner Nutzer aufzuzeichnen, die gesammelten Daten zu
              analysieren und z.B. personalisierte Werbung anzuzeigen. Diese
              Services ermöglichen es uns, Nutzer über mehrere Websites hinweg
              zu verfolgen.&nbsp;&nbsp;•&nbsp;&nbsp;<a
                href="#"
                style="color: rgb(124, 124, 124); text-decoration: none"
                >Service-Informationen anzeigen</a
              >
            </div>
          </div>
        </div>
        <div
        @click="saveSettings()"
          style="
            text-decoration: none;
            border-radius: 1px;
            cursor: pointer;
            background-color: rgb(69, 179, 221);
            font-size: 19px;
            font-weight: normal;
            color: rgb(255, 255, 255);
            transition: background-color 250ms ease 0s, color 250ms ease 0s,
              border-color 250ms ease 0s;
            margin: 0px 0px 10px;
            padding: 10px;
            overflow: hidden;
            flex: 1 1 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            order: 0;
          "
        >
         <span
          
            style="
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: keep-all;
              overflow: hidden;
              cursor: pointer;
            "
            >Auswahl Speichern</span
          >
      </div>
      </div>

      <div style="clear: both"></div>

    </div>
  </div>
</template>

<script>
export default {
  name: "CookieDialog",
  data() {
    return {
      show_settings: false,
      amount_cookies: {
        essentiel: 2,
        marketing: 0,
        stats: 0,
        functional: 0,
      },
      want_marketing: false,
      want_stat: false,
      want_functional: false,
    };
  },
   mounted() {
    var cookieRaw = this.getCookie("cookie_banner");
    if (cookieRaw) {
      var payload = JSON.parse(cookieRaw);
      this.want_marketing = payload.want_marketing;
      this.want_stat = payload.want_marketing;
      this.want_functional = payload.want_marketing;
      this.$emit("close");
    }
  },
  methods: {
    getCookie(name) {
      var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
      return v ? v[2] : null;
    },
    setCookie(name, value, days) {
      var d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie =
        name + "=" + value + ";path=/;expires=" + d.toGMTString();
    },
    deleteCookie(name) {
      setCookie(name, "", -1);
    },
    saveSettingsToCookie() {
      var payload = {
        want_marketing: this.want_marketing,
        want_stat: this.want_stat,
        want_functional: this.want_functional,
      };

      this.setCookie("cookie_banner", JSON.stringify(payload), 30);
    },
    showSettings() {
      this.show_settings = true;
    },
    saveSettings() {
      this.saveSettingsToCookie();
      this.$emit("close");
    },
    allowAllCookies() {
      this.want_marketing = true;
      this.want_stat = true;
      this.want_functional = true;
      this.saveSettings();
    },
    keepSettings() {
      this.$emit("close");
    },
  }
};
</script>

<style scoped>
</style>
